<template>
	<div class="center_right">
		<div class="center_commNav">
			<div class="center_commNavItem" @click="activeName=item.id" :class="{'active':activeName==item.id}" v-for="(item,index) in commNavs">{{item.name}}</div>
		</div>
		<div v-show="activeName=='1'">
			<div class="center_filter">
				<div class="center_filterInput">
					<el-form :inline="true" label-width="100px">
						<el-form-item label="题目名称：">
							<el-input v-model="finiOntopicName" placeholder="请输入题目名称" clearable></el-input>
						</el-form-item>
						<el-form-item label="题目类型：">
							<el-select :popper-append-to-body='false' v-model="finiOntopicType" placeholder="请选择题目类型" clearable>
								<el-option :label="item.name" :value="item.id" v-for='(item,index) in topicTypes'></el-option>
							</el-select>
						</el-form-item>
						<el-form-item>
							<div class="center_filterBtns">
								<el-button @click="finiOnCurrentChange(1)" type='primary'>搜索</el-button>
								<el-button @click='clearfiniOnFilter'>重置</el-button>
							</div>
						</el-form-item>
					</el-form>
				</div>
			</div>
			<div class="center_tables center_labtables">
				<el-table :data="finiOnlistData" border stripe>
					<emptymain slot='empty' :emptylist='finiOnlistData'></emptymain>
					<el-table-column label="题目名称" prop="question" align='center'></el-table-column>
					<el-table-column label="题目类型" align='center'>
						<template slot-scope="scope">
							<el-tag type='warning' v-for="(item,index) in topicTypes" v-if='scope.row.topicType == item.id'>{{item.name}}</el-tag>
						</template>
					</el-table-column>
					<el-table-column label="难度" prop="difficultly" align='center'></el-table-column>
					<el-table-column label="出错次数" prop="errorCount" align='center'></el-table-column>
					<el-table-column label="操作" align='center'>
						<template slot-scope="scope">
							<el-button plain size='medium' @click="toveiw(scope.row,'exper')">查看详情</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="all_current">
				<el-pagination prev-text='上一页' next-text='下一页' background @current-change="finiOnCurrentChange" :current-page="finiOncurrent" :page-size="limit" layout="total,  prev, pager, next" :total="finiOntotal">
				</el-pagination>
			</div>
		</div>
		<div v-show="activeName=='2'">
			<div class="center_filter">
				<div class="center_filterInput">
					<el-form :inline="true" label-width="100px">
						<el-form-item label="题目名称：">
							<el-input v-model="finiOfftopicName" placeholder="请输入题目名称" clearable></el-input>
						</el-form-item>
						<el-form-item label="题目类型：">
							<el-select :popper-append-to-body='false' v-model="finiOfftopicType" placeholder="请选择题目类型" clearable>
								<el-option :label="item.name" :value="item.id" v-for='(item,index) in topicTypes'></el-option>
							</el-select>
						</el-form-item>
						<!--<el-form-item label="专业名称：">
							<el-select :popper-append-to-body='false' v-model="finiOfftypeId" placeholder="请选择专业名称" clearable>
								<el-option :label="item.name" :value="item.id" v-for='(item,index) in typeList'></el-option>
							</el-select>
						</el-form-item>-->
						<el-form-item>
							<div class="center_filterBtns">
								<el-button @click="finiOffCurrentChange(1)" type='primary'>搜索</el-button>
								<el-button @click='clearfiniOffFilter'>重置</el-button>
							</div>
						</el-form-item>
					</el-form>
				</div>
			</div>
			<div class="center_tables center_labtables">
				<el-table :data="finiOfflistData" border stripe>
					<emptymain slot='empty' :emptylist='finiOfflistData'></emptymain>
					<el-table-column label="题目名称" prop="question" align='center'></el-table-column>
					<el-table-column label="题目类型" align='center'>
						<template slot-scope="scope">
							<el-tag type='warning' v-for="(item,index) in topicTypes" v-if='scope.row.topicType == item.id'>{{item.name}}</el-tag>
						</template>
					</el-table-column>
					<el-table-column label="难度" prop="difficultly" align='center'></el-table-column>
					<el-table-column label="出错次数" prop="errorCount" align='center'></el-table-column>
					<el-table-column label="操作" align='center'>
						<template slot-scope="scope">
							<el-button plain size='medium' @click="toveiw(scope.row,'task')">查看详情</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="all_current">
				<el-pagination prev-text='上一页' next-text='下一页' background @current-change="finiOffCurrentChange" :current-page="finiOffcurrent" :page-size="limit" layout="total,  prev, pager, next" :total="finiOfftotal">
				</el-pagination>
			</div>
		</div>
		<div v-show="activeName=='3'">
			<div class="center_filter">
				<div class="center_filterInput">
					<el-form :inline="true" label-width="100px">
						<el-form-item label="题目名称：">
							<el-input v-model="finiOthname" placeholder="请输入题目名称" clearable></el-input>
						</el-form-item>
						<el-form-item label="题目类型：">
							<el-select :popper-append-to-body='false' v-model="finiOthtopicType" placeholder="请选择题目类型" clearable>
								<el-option :label="item.name" :value="item.id" v-for='(item,index) in topicTypes'></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="考试名称：">
							<el-input v-model="finiOthtypeId" placeholder="请输入考试名称" clearable></el-input>
						</el-form-item>
						<el-form-item>
							<div class="center_filterBtns">
								<el-button @click="finiOthCurrentChange(1)" type='primary'>搜索</el-button>
								<el-button @click='clearfiniOthFilter'>重置</el-button>
							</div>
						</el-form-item>
					</el-form>
				</div>
			</div>
			<div class="center_tables center_labtables">
				<el-table :data="finiOthlistData" border stripe>
					<emptymain slot='empty' :emptylist='finiOthlistData'></emptymain>
					<el-table-column label="题目名称" prop="question" align='center'></el-table-column>
					<el-table-column label="题目类型" align='center'>
						<template slot-scope="scope">
							<el-tag type='warning' v-for="(item,index) in topicTypes" v-if='scope.row.topicType == item.id'>{{item.name}}</el-tag>
						</template>
					</el-table-column>
					<el-table-column label="考试名称" prop="examineName" align='center'></el-table-column>
					<el-table-column label="难度" prop="difficultly" align='center'></el-table-column>
					<el-table-column label="出错次数" prop="errorCount" align='center'></el-table-column>
					<el-table-column label="操作" align='center'>
						<template slot-scope="scope">
							<el-button plain size='medium' @click="toveiw(scope.row,'exam')">查看详情</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="all_current">
				<el-pagination prev-text='上一页' next-text='下一页' background @current-change="finiOthCurrentChange" :current-page="finiOthcurrent" :page-size="limit" layout="total,  prev, pager, next" :total="finiOthtotal">
				</el-pagination>
			</div>
		</div>
		<el-dialog title="错题详情" class="open_dialogInfo" :visible.sync="viewDialog" :append-to-body='true' width="1000px" :close-on-click-modal='false' :close-on-press-escape='false'>
			<task-info v-if='viewDialog' :viewItem='viewItem' :viewCheck='viewCheck'></task-info>
		</el-dialog>
	</div>
</template>

<script>
	import { topiclist, getUserTaskErrorTopic, getUserErrorInfo, getUserExamErrorTopic, getUserExamErrorInfo, getUserErrorTopic, getExperErrorInfo, getUserSeltTestTopic, getUserSeltTestTopicDetail } from '@/api/topic.js'
	import { listMajorByPid } from '@/api/major'
	import taskInfo from '@/views/center/components/centerErrorDetails.vue'
	export default {
		components: {
			taskInfo
		},
		data() {
			return {
				activeName: '1',
				commNavs: [{
					name: '虚拟仿真',
					id: '1'
				}, {
					name: '在线课程',
					id: '2'
				}, {
					name: '在线考试',
					id: '3'
				}],
				limit: 10,
				typeList: [],
				topicTypes: [{
					id: '1',
					name: '单选题'
				}, {
					id: '2',
					name: '多选题'
				}, {
					id: '3',
					name: '判断题'
				}, {
					id: '4',
					name: '填空题'
				}, {
					id: '5',
					name: '简答题'
				}],

				//虚拟仿真
				finiOntopicName: '',
				finiOnname: '',
				finiOntypeId: '',
				finiOntopicType: '',
				finiOntaskName: '',
				finiOnlistData: [],
				finiOncurrent: 1,
				finiOntotal: 0,
				//在线课程
				finiOfftopicName: '',
				finiOfftaskName: '',
				finiOffname: '',
				finiOfftypeId: '',
				finiOfftopicType: '',
				finiOfflistData: [],
				finiOffcurrent: 1,
				finiOfftotal: 0,
				//在线考试
				finiOthtopicName: '',
				finiOthname: '',
				finiOthtypeId: '',
				finiOthtopicType: '',
				finiOthlistData: [],
				finiOthcurrent: 1,
				finiOthtotal: 0,
				//详情
				viewDialog: false,
				viewItem: {},
				viewType: '',
				viewTopicId: '',
				viewCheck: '',
			}
		},
		created() {
			this.getTypeList();
			this.getfiniOnListData();
			this.getfiniOffListData();
			this.getfiniOthListData();
		},
		methods: {
			clearfiniOnFilter() {
				this.finiOntopicName = '';
				this.finiOntaskName = '';
				this.finiOnname = '';
				this.finiOntypeId = '';
				this.finiOntopicType = '';
				this.finiOncurrent = 1
				this.getfiniOnListData();
			},
			finiOnCurrentChange(finiOncurrent) {
				this.finiOncurrent = finiOncurrent;
				this.getfiniOnListData();
			},
			getfiniOnListData() {
				var data = {
					name: this.finiOnname ? this.finiOnname : null,
					question: this.finiOntopicName ? this.finiOntopicName : null,
					typeId: this.finiOntypeId ? this.finiOntypeId : null,
					topicType: this.finiOntopicType ? this.finiOntopicType : null,
					current: this.finiOncurrent,
					limit: this.limit,
				}
				getUserErrorTopic(data).then(res => {
					if(res.code == "OK") {
						this.finiOnlistData = res.data.records;
						this.finiOntotal = res.data.total;
					}
				})
			},
			clearfiniOffFilter() {
				this.finiOffname = '';
				this.finiOfftopicName = '';
				this.finiOfftaskName = '';
				this.finiOfftypeId = '';
				this.finiOfftopicType = '';
				this.finiOffcurrent = 1
				this.getfiniOffListData();
			},
			finiOffCurrentChange(finiOffcurrent) {
				this.finiOffcurrent = finiOffcurrent;
				this.getfiniOffListData();
			},
			getfiniOffListData() {
				var data = {
					courseName: this.finiOffname ? this.finiOffname : null,
					typeId: this.finiOfftypeId ? this.finiOfftypeId : null,
					question: this.finiOfftopicName ? this.finiOfftopicName : null,
					topicType: this.finiOfftopicType ? this.finiOfftopicType : null,
					current: this.finiOffcurrent,
					limit: this.limit,
				}
				getUserTaskErrorTopic(data).then(res => {
					if(res.code == "OK") {
						this.finiOfflistData = res.data.records;
						this.finiOfftotal = res.data.total;
					}
				})
			},
			clearfiniOthFilter() {
				this.finiOthtopicName = '';
				this.finiOthname = '';
				this.finiOthtypeId = '';
				this.finiOthtopicType = '';
				this.finiOthcurrent = 1
				this.getfiniOthListData();
			},
			finiOthCurrentChange(finiOthcurrent) {
				this.finiOthcurrent = finiOthcurrent;
				this.getfiniOthListData();
			},
			getfiniOthListData() {
				var data = {
					question: this.finiOthname ? this.finiOthname : null,
					topicType: this.finiOthtopicType ? this.finiOthtopicType : null,
					examineName: this.finiOthtypeId ? this.finiOthtypeId : null,
					current: this.finiOthcurrent,
					limit: this.limit,
				}
				getUserExamErrorTopic(data).then(res => {
					if(res.code == "OK") {
						this.finiOthlistData = res.data.records;
						this.finiOthtotal = res.data.total;
					}
				})
			},
			toveiw(item, check) {
				this.viewItem = Object.assign({},item);
				this.viewCheck = check;
				this.viewDialog = true;
			},
			getTypeList() {
				listMajorByPid({
					pid: this.majorIdForAll
				}).then(res => {
					this.typeList = res.data;
				})
			},
		},
	};
</script>